import { render } from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=template&id=40383556&scoped=true"
import script from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=script&lang=js"
export * from "./FamilyIncomeBenefitPlanSelection.vue?vue&type=script&lang=js"

import "./FamilyIncomeBenefitPlanSelection.vue?vue&type=style&index=0&id=40383556&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\ProtectionGuruVue\\client-app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40383556"]])

export default __exports__